import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Input, InputGroup, InputGroupText, Row, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";

import {
    ASSIGN_PRICES,
    CURRENCY_MXN_HEADER,
    CURRENCY_USD_HEADER,
    error,
    infoMsg, PRICE_BOTTLE_HEADER,
    PRICE_CUP_HEADER,
    SAVE,
    saveMsg,
    success,
} from "../i18n/i18n";
import { ButtonCancel } from "../buttons/buttonsActions";
import {dishDrinkPriceService} from "../../jwt/_services/ayb/dishDrinkPriceService";
import {showToastCustom} from "../toast/customToast";

export const ConfirmAssignPriceForm = ({ item, fbDataBaseId, onClose, updateList }) => {

    const [saving, setSaving] = useState(false)

    const [priceUSD, setPriceUSD] = useState('0.00')
    const [priceMXN, setPriceMXN] = useState('0.00')
    const [priceCupMXN, setPriceCupMXN] = useState('0.00')
    const [priceCupUSD, setPriceCupUSD] = useState('0.00')
    const [priceIdUSD, setPriceIdUSD] = useState(null)
    const [priceIdMXN, setPriceIdMXN] = useState(null)
    const [priceCupIdUSD, setPriceCupIdUSD] = useState(null)
    const [priceCupIdMXN, setPriceCupIdMXN] = useState(null)

    const {register, handleSubmit } = useForm({
        defaultValues: {
            priceUSD: '0.00',
            priceMXN: '0.00',
            priceCupMXN: '0.00',
            priceCupUSD: '0.00',
        }
    });

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    useEffect(() => {
        item.prices.map(price => {
            if (price.currencyCode === 'MXN' && (price.presentationType === null || price.presentationType === 'BOTTLE')) {
                setPriceMXN(price.price)
                setPriceIdMXN(price.id || null)
            }

            if (price.currencyCode === 'USD' && (price.presentationType === null || price.presentationType === 'BOTTLE')) {
                setPriceUSD(price.price)
                setPriceIdUSD(price.id || null)
            }

            if (price.currencyCode === 'MXN' && price.presentationType === 'CUP') {
                setPriceCupMXN(price.price)
                setPriceCupIdMXN(price.id || null)
            }

            if (price.currencyCode === 'USD' && price.presentationType === 'CUP') {
                setPriceCupUSD(price.price)
                setPriceCupIdUSD(price.id || null)
            }
        });
    },[])

    const onSubmit = (values, _) => {
        const dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                items : [ ]
            }
        }

        if (parseFloat(priceMXN) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id : priceIdMXN,
                    currency : { currency : 'MXN' },
                    dishDrink : { id : item.id },
                    presentationType : 'BOTTLE',
                    price : priceMXN
                }
            ]
        }

        if (parseFloat(priceUSD) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id: priceIdUSD,
                    currency : { currency : 'USD' },
                    dishDrink : { id : item.id },
                    presentationType : 'BOTTLE',
                    price : priceUSD
                }
            ]
        }

        if (parseFloat(priceCupMXN) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id : priceCupIdMXN,
                    currency : { currency : 'MXN' },
                    dishDrink : { id : item.id },
                    presentationType : 'CUP',
                    price : priceCupMXN
                }
            ]
        }

        if (parseFloat(priceCupUSD) > 0) {
            dataRequest.item.items = [
                ...dataRequest.item.items,
                {
                    id : priceCupIdUSD,
                    currency : { currency : 'USD' },
                    dishDrink : { id : item.id },
                    presentationType : 'CUP',
                    price : priceCupUSD
                }
            ]
        }

        setSaving(true)
        dishDrinkPriceService.saveItem(dataRequest)
            .then(result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
                onClose();
            })
            .catch( e => {
                    console.log("Error en la asignacion", e);
                    showToastCustom(error, infoMsg, true);
                }
            )
            .finally(() => {
                if(isMounted.current) {
                    setSaving(false)
                }
                updateList()
                onClose()
            });
    }

    return (
        <div className='custom-ui-auto-width'>
            <h1>{ASSIGN_PRICES}</h1>

            <br/>
            <div style={{textAlign:'left'}}>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    <Row>
                        <Col md={"4"}/>
                        <Col md={"4"}><h4 style={ {textAlign:'center'} }>{CURRENCY_USD_HEADER}</h4></Col>
                        <Col md={"4"}><h4 style={ {textAlign:'center'} }>{CURRENCY_MXN_HEADER}</h4></Col>
                    </Row>
                    <Row>
                        <Col md={"4"}>{ PRICE_BOTTLE_HEADER }</Col>
                        <Col md={"4"} style={ { borderRight:'solid' } }>
                            <InputGroup>
                                <InputGroupText>$</InputGroupText>
                                <Input
                                    type="number"
                                    step=".01"
                                    min="0.00"
                                    name="priceUSD"
                                    value={priceUSD}
                                    onChange={e => setPriceUSD(e.target.value)}
                                    placeholder={''}
                                    innerRef={register}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={"4"}>
                            <InputGroup>
                                <InputGroupText>$</InputGroupText>
                                <Input
                                    type="number"
                                    step=".01"
                                    min="0.00"
                                    name="priceMXN"
                                    value={priceMXN}
                                    onChange={e => setPriceMXN(e.target.value)}
                                    placeholder={''}
                                    innerRef={register}
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <br/>
                    <br/>
                    <Row>
                        <Col md={"4"}>{ PRICE_CUP_HEADER }</Col>
                        <Col md={"4"} style={ { borderRight:'solid' } }>
                            <InputGroup>
                                <InputGroupText>$</InputGroupText>
                                <Input
                                    type="number"
                                    step=".01"
                                    min="0.00"
                                    name="priceCupUSD"
                                    value={priceCupUSD}
                                    onChange={e => setPriceCupUSD(e.target.value)}
                                    placeholder={''}
                                    innerRef={register}
                                />
                            </InputGroup>
                        </Col>
                        <Col md={"4"}>
                            <InputGroup>
                                <InputGroupText>$</InputGroupText>
                                <Input
                                    type="number"
                                    step=".01"
                                    min="0.00"
                                    name="priceCupMXN"
                                    value={priceCupMXN}
                                    onChange={e => setPriceCupMXN(e.target.value)}
                                    placeholder={''}
                                    innerRef={register}
                                />
                            </InputGroup>
                        </Col>
                    </Row>

                    <br/>
                    <br/>

                    <div style={{textAlign:'center'}}>
                        <ButtonCancel onClick={onClose}/>
                        &nbsp;&nbsp;
                        <Button
                            type={"submit"}
                            className="btn-add ml-auto ml-2"
                            disabled={ saving }
                        >
                            { SAVE }
                        </Button>
                        {
                            saving && <>
                                <br/><br/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                            </>
                        }
                    </div>
                </Form>
            </div>
        </div>
    );
}